exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lsac .account-details p, .lsac .account-details button {\n  font-size: 16px; }\n\n.act-button {\n  margin-bottom: 1em;\n  width: 186px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/lsac/lsac.scss
// module id = ncoU
// module chunks = 3